import React, { useEffect, useState } from "react";
import Button from "../atoms/Button";
import { useTranslation } from "react-i18next";
import Paragraph from "../atoms/Paragraph";
import Box from "../atoms/Box";
import { useSelector } from "react-redux";
import styled from "styled-components";

const StyledParagraph = styled(Paragraph)`
  font-size: 17px;
  line-height: 1.8rem;
  font-weight: 400;
  color: ${props => props.theme.textLight};
`;

const DebtCollectorModal = ({ onRequestClose }) => {
  const { t } = useTranslation();

  const { isLoading } = useSelector(state => state.data);
  const { debt_collector_message } = useSelector(state => state.data.settings);

  return (
    <>
      <Box margin="0 0 25px">
        <StyledParagraph>{debt_collector_message}</StyledParagraph>
      </Box>
      <Button loading={isLoading} reversed primary onClick={onRequestClose}>
        {t("debt_collector.button")}
      </Button>
    </>
  );
};

export default DebtCollectorModal;
